const CustomerType = {
  CUSTOMER: 1,
  USER_GHOST: 2
}
export default CustomerType
